import { HttpLink } from '@apollo/client/link/http';

export const httpLink = new HttpLink({
  uri: '/graphql',
});
